import { render, staticRenderFns } from "./ConsentGrantsForm.vue?vue&type=template&id=554beb1d&"
import script from "./ConsentGrantsForm.vue?vue&type=script&lang=ts&"
export * from "./ConsentGrantsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554beb1d')) {
      api.createRecord('554beb1d', component.options)
    } else {
      api.reload('554beb1d', component.options)
    }
    module.hot.accept("./ConsentGrantsForm.vue?vue&type=template&id=554beb1d&", function () {
      api.rerender('554beb1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaignFactory/Test/ConsentGrantsForm.vue"
export default component.exports